import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from './../../../../shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';;
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';

@Component({
  selector: 'app-reporte-presupuesto-promocional',
  templateUrl: './reporte-presupuesto-promocional.component.html',
  styleUrls: ['./reporte-presupuesto-promocional.component.css']
})


export class ReportePresupuestoPromocionalComponent implements OnInit {
  titulo: string = 'Reporte Presupuesto Promocional';
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  columnDefs: any[];//aggrid
  defaultColDef: {};//aggrid

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  modulo: any = {};

  cmbxCanalVenta    : any[] = [];
  cmbxUnidadNegocio : any[] = [];
  cmbxCanal         : any[] = [];
  cmbxSubCanal      : any[] = [];
  cmbxgrupoCliente  : any[] = [];

  constructor(    
    private fb: FormBuilder,
    private _util: UtilsService,
    private _indicadores: IndicadoresVivosService,
    private _dmaestrosServices : DatosMaestrosService,
    private catalogoPresupuesto: CatalogoIndicadoresService,
  ) { }


  ngOnInit(): void {
    this.formulario = this.fb.group({
      anio      : ['', [Validators.required, 
                        Validators.pattern(/[0-9]+/), 
                        Validators.maxLength(4), 
                        Validators.minLength(4),
                        Validators.min(2000)]],
      canal         : [''],
      unidadNegocio : [''],
      canalVendedor : [''],
      subCanal      : [''],
      grupoCliente  : [''],
      material      : ['', [Validators.pattern(/[0-9]+/), Validators.maxLength(10), Validators.minLength(4)]],
    });

    this.cargarGrid();
    this.inicializaCombos();
    this.modulo = indicadoresVivosModulo;

  }


  onQuickFilterChanged() {
    // this.gridApi.setQuickFilter(this.textoBuscar);
  }
  

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      { field: 'anio',                sortable: true, filter: true, resizable: true },
      { field: 'idOrganizacionVenta', sortable: true, filter: true, resizable: true },
      { field: 'organizacionVentaDsca', sortable: true, filter: true, resizable: true },
      { field: 'idCanalVenta',    sortable: true, filter: true, resizable: true },
      { field: 'canalVentaDsca',  sortable: true, filter: true, resizable: true },
      { field: 'idUnidadNegocio', sortable: true, filter: true, resizable: true },
      { field: 'unidadNegocioDsca', sortable: true, filter: true, resizable: true },

      /* T25111 | ALCANCE: comentar definiciones de cabecera de plantilla y reporte. Omite campos CANAL, SUBCANAL Y GRUPO CLIENTES
      NO BORRAR, SE ESPERA A FUTURO ACTIVAR*/
      /*
      { field: 'idCanal',         sortable: true, filter: true, resizable: true }, 
      { field: 'canalVendedorDsca', sortable: true, filter: true, resizable: true },
      { field: 'idSubCanal',      sortable: true, filter: true, resizable: true },
      { field: 'subCanalDsca',    sortable: true, filter: true, resizable: true },
      { field: 'idGrupoCliente',  sortable: true, filter: true, resizable: true },
      { field: 'grupoClienteDsca', sortable: true, filter: true, resizable: true },*/
      { field: 'material',        sortable: true, filter: true, resizable: true },
      { field: 'materialDsca',    sortable: true, filter: true, resizable: true },
      { field: 'macroCategoria',  sortable: true, filter: true, resizable: true },
      { field: 'macroCategoriaDsca',  sortable: true, filter: true, resizable: true },
      { field: 'categoria',       sortable: true, filter: true, resizable: true },
      { field: 'categoriaDsca',  sortable: true, filter: true, resizable: true },
      { field: 'subCategoria',    sortable: true, filter: true, resizable: true },
      { field: 'subCategoriaDsca',  sortable: true, filter: true, resizable: true },
      { field: 'marca',           sortable: true, filter: true, resizable: true },
      { field: 'marcaDsca',  sortable: true, filter: true, resizable: true },
      { field: 'enero',           sortable: true, filter: true, resizable: true },
      { field: 'febrero',         sortable: true, filter: true, resizable: true },
      { field: 'marzo',           sortable: true, filter: true, resizable: true },
      { field: 'abril',           sortable: true, filter: true, resizable: true },
      { field: 'mayo',            sortable: true, filter: true, resizable: true },
      { field: 'junio',           sortable: true, filter: true, resizable: true },
      { field: 'julio',           sortable: true, filter: true, resizable: true },
      { field: 'agosto',          sortable: true, filter: true, resizable: true },
      { field: 'septiembre',      sortable: true, filter: true, resizable: true },
      { field: 'octubre',         sortable: true, filter: true, resizable: true },
      { field: 'noviembre',       sortable: true, filter: true, resizable: true },
      { field: 'diciembre',       sortable: true, filter: true, resizable: true }
    ];
  }

  getReport() {
    this.loading = true;

    this._indicadores.getReportPresupuestoPromo(
      this.formulario.get('anio').value,
      this.formulario.get('canal').value,
      this.formulario.get('unidadNegocio').value,
      this.formulario.get('canalVendedor').value,
      this.formulario.get('subCanal').value,
      this.formulario.get('grupoCliente').value,
      this.formulario.get('material').value
    ).subscribe((res: any) => {
      this.rowData = res;
      this.listaVacia = this.rowData.length === 0 ? true : false;
      this.loading = false;
      this._util.mensajeOKToast("Registros Encontrados.");
      
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.message);
    });
  }

  inicializaCombos(){
    this.loading  = true;
    this.cmbxCanalVenta   = [];
    this.cmbxUnidadNegocio = [];
    this.cmbxCanal =[];
    this.cmbxSubCanal    = [];
    this.cmbxgrupoCliente =[];


    //Unidad de negocio
    this._dmaestrosServices.getAllUnidadNegocio().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.descCorta = e.idUnidad +" - "+e.descCorta;
          return e;          
        });
        this.cmbxUnidadNegocio = response;
        console.log(this.cmbxUnidadNegocio);
      }else{
        this._util.mensajeOKToast("No se encontraron registros", 3000);
      }
    },(err) => { 
      console.log(err.err.message);
    });


    //Canal Vendedor | CANAL
    this._dmaestrosServices.getAllCanalVendedor().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.descCorta = e.idCanal +" - "+e.descCorta;
          return e;          
        });
        this.cmbxCanal = response;
      }else{
        this._util.mensajeOKToast("No se encontraron registros", 3000);
      }
    },(err) => { 
      console.log(err.err.message);
    });

    //Grupo tarifa canal - subcanal
    this._dmaestrosServices.getAllGrupoTarifaCanal().subscribe((response) => {
      if(response.length > 0){
        this.cmbxSubCanal = response;
        console.log(this.cmbxSubCanal);
      }else{
        this._util.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });


    //Canal ventas
    this._dmaestrosServices.getAllCanalVenta().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.dscaCanalVenta = e.idCanalVenta +" - "+e.dscaCanalVenta;
          return e;          
        });
        this.cmbxCanalVenta = response;
      }else{
        this._util.mensajeOKToast("No se encontraron registros", 3000);
      }
    },(err) => { 
      console.log(err.err.message);
    });
    
    //Grupo Clientes o grupo precio ventas
    this._dmaestrosServices.getAllGrupoCliente().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.dscaGrupoCliente = e.idGrupoCliente +" - "+e.dscaGrupoCliente;
          return e;          
        });
        this.cmbxgrupoCliente = response;
      }else{
        this._util.mensajeOKToast("No se encontraron registros", 3000);
      }
    },(err) => { 
      console.log(err.err.message);
    });

    this.loading = false;
  }

  downloadDataCsv() {
    let   data: any = [];
    let   cabecera: any[] = this.catalogoPresupuesto.reporteCabeceraPresuPromocional();
    const dataText: any[] = this.rowData;
    let   name: string = "reporte-presupuesto-promocional.csv";

    let clonData = this.rowData.map((x) => Object.assign({}, x));

    clonData.forEach((e) => {
      if (!e.isCorrect) {
        data.push(
          {
            anio                : e.anio, 
            idOrganizacionVenta : e.idOrganizacionVenta, 
            organizacionVentaDsca : e.organizacionVentaDsca, 
            idCanalVenta        : e.idCanalVenta, 
            canalVentaDsca      : e.canalVentaDsca, 
            idUnidadNegocio     : e.idUnidadNegocio, 
            unidadNegocioDsca   : e.unidadNegocioDsca, 

      /* T25111 | ALCANCE: comentar definiciones de cabecera de plantilla y reporte. Omite campos CANAL, SUBCANAL Y GRUPO CLIENTES
      NO BORRAR, SE ESPERA A FUTURO ACTIVAR*/

           /* idCanal             : e.idCanal, 
            canalVendedorDsca   : e.canalVendedorDsca, 
            idSubCanal          : e.idSubCanal, 
            subCanalDsca        : e.subCanalDsca, 
            idGrupoCliente      : e.idGrupoCliente, 
            grupoClienteDsca    : e.grupoClienteDsca,*/
            
            material            : e.material, 
            materialDsca        : e.materialDsca,  
            macroCategoria      : "'"+e.macroCategoria, 
            macroCategoriaDsca  : e.macroCategoriaDsca, 
            categoria           : "'"+e.categoria, 
            categoriaDsca       : e.categoriaDsca, 
            subcategoria        : "'"+e.subCategoria, 
            subCategoriaDsca    : e.subCategoriaDsca, 
            marca               : "'"+e.marca,
            marcaDsca           : e.marcaDsca,
            enero               : e.enero,
            febrero             : e.febrero,
            marzo               : e.marzo,
            abril               : e.abril,
            mayo                : e.mayo,
            junio               : e.junio,
            julio               : e.julio,
            agosto              : e.agosto,
            septiembre          : e.septiembre,
            octubre             : e.octubre,
            noviembre           : e.noviembre,
            diciembre           : e.diciembre, 
          }
        );
      }
    });

    this._util.exportCSV(cabecera, data, name);
    this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

}
